import type { CSSProperties } from 'react'
import './ArtworkPreviewSurface.css'

type ArtworkPreviewSurfaceProps = {
  alt: string
  className?: string
  imageClassName?: string
  maxHeight?: number | string
  onClick?: () => void
  src: string
}

const previewMaxHeight = (maxHeight: number | string) => (typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight)

const ArtworkPreviewSurface = ({
  alt,
  className = '',
  imageClassName = '',
  maxHeight = '220px',
  onClick,
  src
}: ArtworkPreviewSurfaceProps) => {
  const surfaceClassName =
    `artwork-preview-surface ${onClick ? 'artwork-preview-surface--button' : ''} ${className}`.trim()
  const style = { '--artwork-preview-max-height': previewMaxHeight(maxHeight) } as CSSProperties
  const image = <img className={`artwork-preview-surface__image ${imageClassName}`.trim()} src={src} alt={alt} />

  return onClick ? (
    <button
      type="button"
      className={surfaceClassName}
      style={style}
      onClick={onClick}
      aria-label={`Enlarge ${alt}`}
      aria-haspopup="dialog"
    >
      {image}
    </button>
  ) : (
    <div className={surfaceClassName} style={style}>
      {image}
    </div>
  )
}

export default ArtworkPreviewSurface
